import { render, staticRenderFns } from "./PaymentStudentNoteDialog.vue?vue&type=template&id=be150c76&scoped=true"
import script from "./PaymentStudentNoteDialog.vue?vue&type=script&lang=js"
export * from "./PaymentStudentNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./PaymentStudentNoteDialog.vue?vue&type=style&index=0&id=be150c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be150c76",
  null
  
)

export default component.exports